/**
 * 资源数据配置 - 单层扁平结构
 * @type {Array} 资源列表数组
 * @property {number} sortOrder - 排序权重，数字越小越靠前
 */
export const bilibiliResources = [
    // ========== 置顶推荐 ==========
    {
        id: 'uc-cloud-bonus',
        icon: 'img/uc.jpg',
        isImage: true,
        title: 'UC网盘限时福利',
        description: '限时领1T免费云空间！高速上传下载不限速，数量有限先到先得',
        type: '粉丝福利',
        sortOrder: 1,
        links: {
            primary: { text: '立即领取', url: 'https://broccoli.uc.cn/apps/uc2024_expert_benefits_activity/routes/receive-welfare?_t=AASLCjzfzPbv%2B1tNxPyHnow8f6AWcrcDMmMB3EO3v1jgXOdrzctZgbSjhRvUC68ArJawwKPNvIpUXy2GQTl6O7JG' }
        }
    },
     // ========== 手机软件 ==========
    {
        id: 'anime-apps',
        icon: 'img/jcy.jpg',
        isImage: true,
        title: '12款追番动漫合集',
        description: '囧次元/稀饭动漫等12款热门动漫追番软件',
        type: '影音娱乐',
        sortOrder: 2,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/01ac9bed46d24?public=1' }
        }
    },
    {
        id: 'couple-games',
        icon: 'img/feixingqi.png',
        isImage: true,
        title: '情侣飞行棋4款合集',
        description: '4款情侣互动小游戏，增进感情的小工具',
        type: '娱乐游戏',
        sortOrder: 3,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/00477d3618394?public=1' }
        }
    },
    {
        id: 'magnet-tools',
        icon: 'img/cili.png',
        isImage: true,
        title: '磁力神器合集',
        description: '多款磁力搜索工具，资源获取更便捷',
        type: '下载工具',
        sortOrder: 4,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/111c22f590814?public=1' }
        }
    },
    {
        id: 'reading-app',
        icon: 'img/yuedu.jpg',
        isImage: true,
        title: '阅读APP附4000+书源',
        description: '内置4000+书源的阅读APP，支持全网小说资源',
        type: '阅读工具',
        sortOrder: 5,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/9da23822a27c4?public=1' }
        }
    },
    {
        id: 'comic-novel-apps',
        icon: 'img/kb.png',
        isImage: true,
        title: '20款漫画小说软件',
        description: '拷贝漫画等20款漫画小说阅读软件，海量资源免费阅读',
        type: '阅读工具',
        sortOrder: 6,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/95331c31e9714?public=1' }
        }
    },
    {
        id: 'openclaw',
        icon: 'img/openclaw.png',
        isImage: true,
        title: 'OpenClaw 小龙虾一键部署包',
        description: 'OpenClaw AI工具一键部署包，快速搭建本地AI环境',
        type: 'AI工具',
        sortOrder: 7,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/e7377ece02494?public=1' }
        }
    },
    {
        id: 'luoxue-tools',
        icon: 'img/luoxue.png',
        isImage: true,
        title: '洛雪音乐三端可用',
        description: '洛雪音乐三端可用，支持本地播放和在线搜索，附5条音源',
        type: '音乐工具',
        sortOrder: 8,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/e8da0ba24c164?public=1' }
        }
    },
        // ========== 电视直播 ==========
    {
        id: 'tv-live',
        icon: '📺',
        title: '电视直播TV合集',
        description: '海量电视频道直播，高清流畅随时观看',
        type: '影音娱乐',
        sortOrder: 9,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/84ccff6830084?public=1' }
        }
    },

    // ========== 绿幕素材 ==========
    {
        id: 'cat-meme-green',
        icon: 'img/maomeme.png',
        isImage: true,
        title: '猫meme绿幕素材',
        description: '精选猫meme绿幕素材，适用于各种搞笑剪辑和创作',
        type: '绿幕素材',
        sortOrder: 10,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/e8913953de354?public=1' }
        }
    },
    // ========== 电脑软件 ==========
    {
        id: 'rvc-models',
        icon: '🎤',
        title: 'RVC变声器模型600合集',
        description: '600+款RVC声音模型任你选，支持实时变声和后期处理',
        type: '音频工具',
        sortOrder: 11,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/dc767e9ca7924?public=1' }
        }
    },
    {
        id: 'office-activation',
        icon: '📚',
        title: 'Office365全家桶激活',
        description: 'Office365全套激活工具，支持Word、Excel、PowerPoint等',
        type: '办公软件',
        sortOrder: 12,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/2f4a590f5eaa4?public=1' }
        }
    },
    {
        id: 'jian-ying',
        icon: 'img/jianying.png',
        isImage: true,
        title: '剪映解锁SVIP版',
        description: '解锁剪映SVIP版，畅享全部功能，无VIP限制',
        type: '剪辑工具',
        sortOrder: 13,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/0cc7a313249e4?public=1' }
        }
    },
    {
        id: 'windows-activation',
        icon: '💿',
        title: 'Windows7/10/11激活',
        description: 'Windows系统激活工具 + office激活',
        type: '系统工具',
        sortOrder: 14,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/8f67cf9475794?public=1' }
        }
    },
    {
        id: 'hevc-decoder',
        icon: '🎬',
        title: 'HEVC解码器白嫖',
        description: '免费获取微软HEVC视频解码器，支持4K视频播放',
        type: '视频工具',
        sortOrder: 15,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/f18d747b2aec4?public=1' }
        }
    },
    {
        id: 'disk-cleaner',
        icon: '💾',
        title: 'C盘爆红急救清理',
        description: 'C盘清理工具，一键释放系统空间',
        type: '系统工具',
        sortOrder: 16,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/5d4df1f591f24?public=1' }
        }
    },
      {
        id: 'game-modifiers',
        icon: '⚙️',
        title: '游戏修改器合集',
        description: '多款游戏修改器，提升游戏体验的辅助工具',
        type: '修改工具',
        sortOrder: 17,
        links: {
            primary: { text: '立即保存', url: 'https://drive.uc.cn/s/b6786f4a78b34?public=1' }
        }
    }
];